<script lang="ts">
	import { devices_status } from 'src/stores/device-runtime/status';
	import { beforeUpdate } from 'svelte';
	import { user_settings } from 'src/stores/account/user';
	import { auth_locked_devices } from 'src/stores/device-runtime/local-auth';
	import { devices } from 'src/stores/lists/devices';
	import { os } from 'src/stores/session/native-bridge';
	import { cloud_disabled_devices } from 'src/stores/device-runtime/firmware-ui';

	import { postReq, localReq } from '../../../services/http';
	import { hapticFeedback } from '../../../services/native_container_requests_ios';
	import { getStatus } from '../../../helpers/get_status_settings_helpers';
	import {
		get_gen_2_component_from_category,
		get_local_ip,
		is_gen_2,
		real_id,
	} from '../../../helpers/interface_helpers';
	import { gen1CloudReq } from 'src/services/gen_1_reqs';

	// might have to pass button component as a prop
	// import DoubleIconedButtonIndication from "./ControlButton/DoubleIconedButtonIndication.svelte";
	// import DoubleButton from './ControlButton/DoubleButton.svelte';
	import {
		DeviceButton,
		DeviceButtonV2,
		DoubleDeviceButton,
		DoubleDeviceButtonV2,
		toast,
		type DeviceButtonV2PropsTypes,
		type DoubleDeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
	import { unlockPin } from '../../../helpers/pin_lock_helpers';
	import PinUnlock from '../../../components/PinUnlock.svelte';
	import { format } from 'svelte-i18n';
	import { hasControlRights } from 'src/helpers/user_helpers';

	// import Text from '@Shelly/shelly-design-system/Text/Text.svelte';

	let className = '';
	export { className as class };
	export let device, status;
	export let useV2Components = false;
	export let devBtnsV2Props: {
		deviceButtonV2?: Partial<DeviceButtonV2PropsTypes>;
		doubleDeviceButtonV2?: Partial<DoubleDeviceButtonV2PropsTypes>;
	} = {
		deviceButtonV2: { size: 's' },
		doubleDeviceButtonV2: { size: 's' },
	};

	let isLoading = false;
	let local_ip = false;
	let direction = 'stop';
	// let ison = false;
	let pinLocked;
	let showModal = false;

	let callbackValue;

	let btn1 = false;
	let btn2 = false;

	const isGen2 = is_gen_2(device);

	$: hasRights = hasControlRights(device);

	beforeUpdate(() => {
		local_ip = get_local_ip(device.id);

		pinLocked =
			typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock;

		if (
			device.category !== 'sensor' &&
			typeof status?.[device.category.split('s_')[0] + 's'] !== 'undefined'
		) {
			// ison = status?.rollers?.[0]?.state !== 'stop';
			direction = status?.rollers?.[0].state;
			btn1 = status?.rollers?.[0].state === 'open';
			btn2 = status?.rollers?.[0].state === 'close';
		} else if (device.gen == 2) {
			// ison = status?.['cover:' + device.channel]?.state !== 'stopped';
			direction = status?.['cover:' + device.channel]?.state;
			btn1 = status?.['cover:' + device.channel]?.state === 'opening';
			btn2 = status?.['cover:' + device.channel]?.state === 'closing';
		}
	});

	//ToDO: merge the 2 functions the control is not different
	const handleRequestGen1 = async (dir) => {
		if ((dir === 1 && direction === 'open') || (dir === 0 && direction === 'close')) {
			direction = 'stop';
			if ($cloud_disabled_devices[device.id]) {
				btn1 = false;
				btn2 = false;

				setTimeout(() => {
					getStatus(device);
				}, 10000);
			}
		} else {
			direction = dir === 1 ? 'open' : 'close';
			if ($cloud_disabled_devices[device.id]) {
				btn1 = direction === 'open';
				btn2 = direction === 'close';

				setTimeout(() => {
					getStatus(device);
				}, 10000);
			}
		}

		let isok;
		let res;
		isLoading = true;

		if (local_ip) {
			res = await localReq(
				device,
				`${local_ip}/roller/${device.channel}`,
				'post',
				{ go: direction },
				9000,
				true,
			);

			if (res.isok) {
				status.rollers[0] = res;

				devices_status.update_device_status({
					id: real_id(device.id),
					msg: status,
				});
			} else if (
				!res.isok &&
				typeof $cloud_disabled_devices[device.id] === 'undefined' // is not cloud disabled
				// $auth_locked_devices.indexOf[real_id(device.id)] < 0 // is not in the auth locked list
			) {
				res = await gen1CloudReq(device, 'roller', {
					go: direction,
				});
			}
		} else {
			res = await gen1CloudReq(device, 'roller', {
				go: direction,
			});
		}

		if (res.isok) {
			// }
		} else if ($auth_locked_devices.indexOf(real_id(device.id)) == -1) {
			toast.open({ type: 'danger', title: $format('error_global') });
		}

		isLoading = false;
	};

	const handleRequestGen2 = async (dir) => {
		if ((dir === 1 && direction === 'opening') || (dir === 0 && direction === 'closing')) {
			direction = 'stopped';
			if ($cloud_disabled_devices[device.id]) {
				btn1 = false;
				btn2 = false;

				setTimeout(() => {
					getStatus(device);
				}, 10000);
			}
		} else {
			direction = dir === 1 ? 'opening' : 'closing';
			if ($cloud_disabled_devices[device.id]) {
				btn1 = direction === 'opening';
				btn2 = direction === 'closing';

				setTimeout(() => {
					getStatus(device);
				}, 10000);
			}
		}

		let isok;
		isLoading = true;

		if (local_ip) {
			const url = `${local_ip}/rpc/`;

			const data = {
				id: device.id,
				method: `${get_gen_2_component_from_category(device)}.${
					direction === 'opening' ? 'open' : direction === 'closing' ? 'close' : 'stop'
				}`,
				params: { id: device.channel },
			};

			const res = await localReq(device, url, 'post', data, 6000, !is_gen_2);

			// add error handle here
			if (res.isok) {
				status['cover:' + device.channel] = {
					res,
					...status['cover:' + device.channel],
				};

				devices_status.update_device_status({
					id: real_id(device.id),
					msg: status,
				});
			} else {
				console.error('Device control failed');
			}
		} else {
			// TODo: ask SPAS for a better endpoint /device/${device.category}/control
			const res = await postReq(`/device/relay/roller/control`, {
				id: real_id(device.id),
				channel: device.channel,
				direction: direction === 'opening' ? 'open' : direction === 'closing' ? 'close' : 'stop',
			});
			// add error handle here
			if (res.isok) {
				status['cover:' + device.channel] = {
					res,
					...status['cover:' + device.channel],
				};

				devices_status.update_device_status({
					id: real_id(device.id),
					msg: status,
				});
			} else {
				console.error('Device control failed');
			}
		}

		isLoading = false;
	};

	const handleRequest = (dir) => {
		if (!pinLocked) {
			if ($os === 'IOS') {
				hapticFeedback('buttonPressed');
			}
			if (isGen2) {
				handleRequestGen2(dir);
			} else {
				handleRequestGen1(dir);
			}
		} else {
			callbackValue = dir;
			showModal = true;
		}
	};

	const handlePin = () => {
		pinLocked = unlockPin(device, pinLocked);
		handleRequest(callbackValue);
		callbackValue = undefined;
	};
</script>

{#if useV2Components}
	<DoubleDeviceButtonV2
		id="doubledevicebutton-3vc9a1r"
		aria-label={$format('label_direction', { default: 'Direction' })}
		isActive={btn1 || btn2}
		{isLoading}
		class={className}
		disabled={!hasRights}
		{...devBtnsV2Props.doubleDeviceButtonV2}
	>
		<DeviceButtonV2
			id="devicebutton-d6dew5o"
			aria-label={$format('label_direction_up', { default: 'Direction Up' })}
			aria-pressed={btn1}
			slot="buttonLeft"
			icon={btn1 ? 'fa fa-pause' : 'fa fa-arrow-up'}
			isActive={false}
			on:click={(e) => {
				e.stopPropagation();
				handleRequest(1);
			}}
			{...devBtnsV2Props.deviceButtonV2}
		/>
		<DeviceButtonV2
			id="devicebutton-324r8yi"
			aria-label={$format('label_direction_down', { default: 'Direction Down' })}
			aria-pressed={btn2}
			slot="buttonRight"
			icon={btn2 ? 'fa fa-pause' : 'fa fa-arrow-down'}
			isActive={false}
			on:click={(e) => {
				e.stopPropagation();
				handleRequest(0);
			}}
			{...devBtnsV2Props.deviceButtonV2}
		/>
	</DoubleDeviceButtonV2>
{:else}
	<DoubleDeviceButton
		id="doubledevicebutton-3vc9a1r"
		aria-label={$format('label_direction', { default: 'Direction' })}
		isActive={btn1 || btn2}
		{isLoading}
		class={className}
		disabled={!hasRights}
	>
		<DeviceButton
			id="devicebutton-d6dew5o"
			aria-label={$format('label_direction_up', { default: 'Direction Up' })}
			aria-pressed={btn1}
			slot="buttonLeft"
			icon={btn1 ? 'fa fa-pause' : 'fa fa-arrow-up'}
			on:click={(e) => {
				e.stopPropagation();
				handleRequest(1);
			}}
		/>
		<DeviceButton
			id="devicebutton-324r8yi"
			aria-label={$format('label_direction_down', { default: 'Direction Down' })}
			aria-pressed={btn2}
			slot="buttonRight"
			icon={btn2 ? 'fa fa-pause' : 'fa fa-arrow-down'}
			on:click={(e) => {
				e.stopPropagation();
				handleRequest(0);
			}}
		/>
	</DoubleDeviceButton>
{/if}

{#if showModal}
	<PinUnlock bind:showModal on:unlock={handlePin} on:cancel={() => (showModal = false)} />
{/if}
